import { SwarmPlotCustomLayerProps } from '@nivo/swarmplot'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { entries, groupBy } from 'lodash'
import { ComparisonDatum } from 'ComponentLibrary/src/molecules/ComparisonChart/types'
import { estimateLabelWidth } from 'ComponentLibrary/src/molecules/ComparisonChart/labels'

export const ComparisonChartAnnotation = ({ nodes, innerWidth }: SwarmPlotCustomLayerProps<ComparisonDatum>) => {
    const nodesByGroup = groupBy(nodes, 'data.group')
    return entries(nodesByGroup).flatMap(([groupKey, nodesInGroup]) =>
        nodesInGroup.map((node) => {
            const otherNodes = nodesInGroup.filter((otherNode) => otherNode.id !== node.id)
            const estimatedNodeLabelWidth = estimateLabelWidth(node.data.label)
            const estimatedNodeValueWidth = estimateLabelWidth(node.formattedValue)

            const isLabelOverlap = otherNodes.some(
                (sibling) =>
                    Math.max(
                        (estimateLabelWidth(sibling.data.label) + estimatedNodeLabelWidth) / 2,
                        (estimateLabelWidth(sibling.formattedValue) + estimatedNodeValueWidth) / 2
                    ) > Math.abs(sibling.x - node.x)
            )

            const isCloseToEdge =
                node.x - Math.max(estimatedNodeLabelWidth, estimatedNodeValueWidth) / 2 < 0 ||
                node.x + Math.max(estimatedNodeLabelWidth, estimatedNodeValueWidth) / 2 > innerWidth

            const label = isLabelOverlap || isCloseToEdge ? '...' : node.data.label
            const value = isLabelOverlap || isCloseToEdge ? '...' : node.formattedValue

            return (
                <g key={`${groupKey}-${node.id}`} transform={`translate(${node.x}, ${node.y})`} cursor="default">
                    <text
                        y={6}
                        textAnchor="middle"
                        paintOrder="stroke"
                        strokeWidth={3}
                        stroke={tokens.ColorBorderInverse}
                        fill={tokens.ColorGraphNeutralMedium}
                        fontSize={tokens.FontSize2xs}
                        style={{ textTransform: 'uppercase' }}
                    >
                        {label}
                    </text>
                    <text
                        y={22}
                        textAnchor="middle"
                        paintOrder="stroke"
                        strokeWidth={3}
                        stroke={tokens.ColorBorderInverse}
                        fill={tokens.ColorGraphNeutralDarkest}
                        fontSize={tokens.FontSizeXs}
                    >
                        {value}
                    </text>
                </g>
            )
        })
    )
}
